export default "__VITE_ASSET__ChLHC8L7__"